import {Component, Input, OnInit} from '@angular/core';
import {InfoRadioTexte} from "../../../../../../../../model/vorhersagen/rbb-document";

@Component({
  selector: 'app-inforadio-text-bericht',
  templateUrl: './inforadio-text-bericht.component.html',
  styleUrls: ['./inforadio-text-bericht.component.css','../../../wetterbericht.component.css']
})
export class InforadioTextBerichtComponent{

  @Input()
  infoRadioTexte: InfoRadioTexte;


}
